import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["averageRating", "reviewCount", "summary", "setSelectedTab"];
import React from "react";
import { Box, Flex, Heading, Span, StarRating, Text, TextButton } from "@catchoftheday/cg-components";
import { useTheme } from "@catchoftheday/theme";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var ReviewStatistics = function ReviewStatistics(_ref) {
  var averageRating = _ref.averageRating,
      reviewCount = _ref.reviewCount,
      summary = _ref.summary,
      _setSelectedTab = _ref.setSelectedTab,
      boxProps = _objectWithoutProperties(_ref, _excluded);

  var _useTheme = useTheme(),
      backgroundColor = _useTheme.colors.ui.backgroundColor;

  return ___EmotionJSX(Box, _extends({
    position: "relative"
  }, boxProps), averageRating && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Heading.h4, {
    m: 0
  }, "Overall Rating"), ___EmotionJSX(Flex, {
    mt: 4,
    alignItems: "center"
  }, ___EmotionJSX(Text, {
    fontSize: "40px",
    fontWeight: "semibold",
    m: 0,
    lineHeight: 1
  }, averageRating.toFixed(1)), ___EmotionJSX(Flex, {
    flexDirection: "column",
    pl: 2
  }, ___EmotionJSX(StarRating, {
    rating: averageRating,
    backgroundColour: backgroundColor,
    width: 88
  }), ___EmotionJSX(TextButton, {
    mt: 1,
    onClick: function onClick() {
      return _setSelectedTab(5);
    },
    fontWeight: "light",
    textAlign: "left",
    fontSize: "xs"
  }, reviewCount, " ", reviewCount === 1 ? "Review" : "Reviews")))), ___EmotionJSX(Box, {
    mb: 3,
    mt: "14px"
  }, ___EmotionJSX(Heading.h4, {
    mt: 0,
    mb: 2
  }, "Rating Snapshot"), ___EmotionJSX(Box, {
    display: "grid",
    gridTemplateColumns: {
      _: "45px 1fr auto",
      lg: "45px 1fr 106px"
    },
    gap: 2,
    alignItems: "center"
  }, summary.map(function (review, index) {
    return ___EmotionJSX(StatRow, {
      key: review.rating,
      label: "".concat(review.rating, " ").concat(index === 4 ? "Star" : "Stars"),
      count: review.total,
      percentage: review.percentage,
      setSelectedTab: function setSelectedTab() {
        return _setSelectedTab(index);
      }
    });
  }))));
};

var StatRow = function StatRow(_ref2) {
  var label = _ref2.label,
      count = _ref2.count,
      percentage = _ref2.percentage,
      setSelectedTab = _ref2.setSelectedTab;
  var theme = useTheme();
  var percent = "".concat(percentage, "%");
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Text, {
    mr: 2,
    textAlign: "right",
    my: "3px",
    whiteSpace: "nowrap"
  }, label), ___EmotionJSX(Box, {
    height: "8px",
    borderRadius: 4,
    background: "linear-gradient(to right, ".concat(theme.colors.gold, " ").concat(percent, ", ").concat(theme.colors.grey, " ").concat(percent, ")"),
    flexGrow: 1
  }), count > 0 ? ___EmotionJSX(Box, null, ___EmotionJSX(TextButton, {
    onClick: setSelectedTab,
    fontWeight: "light"
  }, count)) : ___EmotionJSX(Span, null, "0"));
};